import { CIStatusCapsule, toLocalDate } from 'ccs-ui-components';
import { STATUS_TYPES } from '../../../../constants';
import { IEventData, IListEventData } from '../../../../store/actions/types/events/GetAllEventListTypes';

/**
 * @method updatedBy
 * @description method to populate created by data cell
 * @param row event data
 * @returns jsx data cell
 */
export const updatedBy = (row: IEventData) => (
  <div className="last-modified-data" title={row.updatedBy}>{row.updatedBy}</div>
);

/**
 * @method renderLastModified
 * @description method to populate last modified column data cell
 * @param row event data
 * @returns jsx data cell
 */
export const renderLastModified = (row: IListEventData) => {
  const date = toLocalDate({ date: row?.updatedTimestamp || '' });
  return (
    <div className="event-list-lastmodified" title={date}> {date}</div>
  );
};

/**
 * @method renderEventStatus
 * @description method to populate a single event status data cell jsx with data
 * @param row event data
 * @returns event status column data cell jsx element
 */
export const renderEventStatus = (row: IEventData) => (
  <div>
    {
      row.status.toLocaleUpperCase() === STATUS_TYPES.RETURNED ? (
        <CIStatusCapsule status={row.status} comment={row?.eventStatusHistory?.find((item) => item?.status?.toLocaleUpperCase() === 'RETURNED')?.comment} />
      ) : (
        <CIStatusCapsule status={row.status} />
      )
    }
  </div>
);
